'use client';

import AppleLogoMobile from '@/components/icons/AppleBrandIcon/AppleBrandIcon';
import PlayLogoMobile from '@/components/icons/GooglePlayBrandIcon/GooglePlayBrandIcon';
import { trackCtaClick } from '@/utils/tracking';

interface MobileDownloadButtonProps {
  url: string;
  buttonText?: string;
  ariaLabel?: string;
}

export const MobileDownloadButton = ({
  url,
  buttonText = 'Get the app!',
  ariaLabel = 'Download the Tempcover app (opens in new tab)',
}: MobileDownloadButtonProps) => {
  return (
    <div className="md:hidden">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        onClick={() => trackCtaClick(buttonText, 'app_download')}
        className="bg-primary text-neutral border-primary-400 hover:shadow-primary/20 active:bg-primary-400 focus-visible:ring-primary flex h-[50px] w-full items-center justify-center gap-3 rounded-[8px] border-1 px-4 text-center text-[16px] font-bold transition-all hover:shadow-xl focus-visible:ring-2 focus-visible:ring-offset-2 active:shadow-none"
      >
        <span className="mr-2 flex items-center gap-1.5" aria-hidden="true">
          <AppleLogoMobile />
          <PlayLogoMobile />
        </span>
        <span>{buttonText}</span>
      </a>
    </div>
  );
};
